import type { TenantModules, TenantModuleTemplate } from '@dosfilos/domain';
import { callable } from '../callable';

// Los módulos que usa un seminario (`setTenantModules`). El administrador del
// seminario los cambia de a uno; la plataforma, además, aplica una plantilla.
export const tenantModulesApi = {
  set: async (input: {
    tenantId: string;
    modules?: TenantModules;
    template?: TenantModuleTemplate;
  }): Promise<{ ok: true; modules: TenantModules }> => {
    const fn = callable<typeof input, { ok: true; modules: TenantModules }>('setTenantModules');
    return (await fn(input)).data;
  },
};
